import React from 'react';
import MasterLayout from '../../components/MasterLayout';

const Stores = () => {
  const columns = [
    { key: 'code', label: 'Code' },
    { key: 'name', label: 'Name' },
    { key: 'store_type', label: 'Type' },
    { key: 'location', label: 'Location' },
    { key: 'is_active', label: 'Status' },
  ];

  const formFields = [
    { name: 'code', label: 'Code', required: true, placeholder: 'STR001' },
    { name: 'name', label: 'Name', required: true, placeholder: 'Store Name' },
    { 
      name: 'store_type', 
      label: 'Store Type', 
      required: true,
      type: 'select',
      options: [
        { value: 'FINISHED_GOODS', label: 'Finished Goods' },
        { value: 'REGRINDING', label: 'Regrinding' },
        { value: 'RAW_MATERIAL', label: 'Raw Material' },
        { value: 'PRODUCTION', label: 'Production' },
        { value: 'REJECTION_AREA', label: 'Rejection Area' },
      ]
    },
    { name: 'location', label: 'Location', placeholder: 'Store Location' },
    { name: 'description', label: 'Description', type: 'textarea', fullWidth: true },
    { name: 'is_active', label: 'Status', type: 'boolean', defaultValue: true },
  ];

  return (
    <MasterLayout
      title="Stores"
      endpoint="stores"
      columns={columns}
      formFields={formFields}
      permissions={['ADMIN', 'RM_STORE']}
    />
  );
};

export default Stores;
